export default __webpack_public_path__ + "static/media/taura_syndrome_virus.32f732dc.jpg";